import React, { useEffect, useRef } from "react";

const WIDGET_TARGET_ID = "ghrianghraffy-gallery-2439";
const WIDGET_SCRIPT_SRC = "https://ghrianghraffy.com/embed/widget.js";
const WIDGET_EMBED_KEY = "1b4tInEr0Ky3-_boSpOC3Q3w7svzdk_IExMdtgZmCTY";

const TestSnippet = () => {
  const mountRef = useRef(null);

  useEffect(() => {
    const mount = mountRef.current;
    if (!mount) return undefined;

    const script = document.createElement("script");
    script.src = WIDGET_SCRIPT_SRC;
    script.setAttribute("data-ghrianghraffy-key", WIDGET_EMBED_KEY);
    script.setAttribute("data-target", WIDGET_TARGET_ID);
    script.defer = true;

    mount.appendChild(script);

    return () => {
      script.remove();

      const target = document.getElementById(WIDGET_TARGET_ID);
      if (target) target.innerHTML = "";
    };
  }, []);

  return (
    <main style={styles.page}>
      <section style={styles.hero}>
        <p style={styles.eyebrow}>GhrianGhraffy website widget test</p>
        <h1 style={styles.title}>School website photo feed</h1>
        <p style={styles.subtitle}>
          This page loads the real GhrianGhraffy JavaScript widget snippet for
          the current test school. It should behave the same way it would on a
          school website.
        </p>
      </section>

      <section style={styles.card}>
        <div ref={mountRef}>
          <div id={WIDGET_TARGET_ID} />
        </div>
      </section>
    </main>
  );
};

const styles = {
  page: {
    maxWidth: 1080,
    margin: "0 auto",
    padding: "48px 18px 72px",
  },
  hero: {
    marginBottom: 28,
  },
  eyebrow: {
    margin: "0 0 10px",
    color: "#00ffaf",
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    fontSize: 13,
  },
  title: {
    margin: "0 0 12px",
    fontSize: "clamp(32px, 6vw, 56px)",
    lineHeight: 1.05,
  },
  subtitle: {
    maxWidth: 720,
    margin: 0,
    fontSize: 17,
    lineHeight: 1.65,
    opacity: 0.82,
  },
  card: {
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 22,
    padding: "clamp(18px, 4vw, 34px)",
    background: "rgba(255,255,255,0.045)",
    boxShadow: "0 18px 60px rgba(0,0,0,0.22)",
  },
};

export default TestSnippet;
